"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceLoopbackAbsoluteOriginWithDocumentWhenHttps = replaceLoopbackAbsoluteOriginWithDocumentWhenHttps;
const browserPublicHostPatterns_1 = require("./browserPublicHostPatterns");
function trimTrailingSlashes(s) {
    return s.replace(/\/+$/, "");
}
function browserHttpsOriginOrNull() {
    if (typeof globalThis === "undefined") {
        return null;
    }
    const w = globalThis.window;
    const loc = w === null || w === void 0 ? void 0 : w.location;
    if (!loc || loc.protocol !== "https:" || typeof loc.origin !== "string") {
        return null;
    }
    return { origin: loc.origin };
}
function replaceLoopbackAbsoluteOriginWithDocumentWhenHttps(absoluteUrl) {
    const t = absoluteUrl.trim();
    const browser = browserHttpsOriginOrNull();
    if (!t || !browser) {
        return t;
    }
    try {
        const u = new URL(t.includes("://") ? t : `https://${t}`);
        if (!(0, browserPublicHostPatterns_1.isLoopbackHostname)(u.hostname)) {
            return t;
        }
        return trimTrailingSlashes(`${browser.origin}${u.pathname}${u.search}`);
    }
    catch {
        return t;
    }
}
